import { HypeItErrorRangeType as ApiHypeItErrorRangeType } from 'src/api/generated/touring/types';
import { HypeItErrorRangeType } from '../../types';

export const mapHypeItErrorRangeType = (
  apiType: ApiHypeItErrorRangeType
): HypeItErrorRangeType => ({
  name: apiType.name,
  start: apiType.start,
  end: apiType.end,
  description: apiType.description,
});
